"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base64ToFile = base64ToFile;
exports.download = download;
exports.downloadByAnchor = downloadByAnchor;
exports.readFile = readFile;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _requests = require("@edison/requests");
var _utils = require("../api/utils");
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _merge = _interopRequireDefault(require("lodash/merge"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import get from 'lodash/get'
// import noop from 'lodash/noop'
// import { FILE_LOAD_ERROR_MESSAGE } from 'utils/constants'
// export type ReadFileOptionals<T> = $Shape<{
//   onAbort: T,
//   onLoadStart: T,
//   onLoadEnd: T,
//   onProgress: T,
//   onLoad: T,
//   onError: T,
// }>
//
// export type ReadFileResult = $ReadOnly<{|
//   abort: () => void,
//   asText: () => Promise<string>,
//   asArrayBuffer: () => Promise<ArrayBuffer>,
//   asDataURL: () => Promise<string>,
// |}>
//
// /**
//  * Util function for reading file
//  *
//  * @public
//  * @param {File} file - File object to read
//  * @param {Object} optionals - Handlers for the process in reading
//  * @returns {Object}
//  */
// export function readFile(
//   file: File,
//   optionals: ReadFileOptionals<(event: Event) => void> = {}
// ): ReadFileResult {
//   const reader = new FileReader()
//
//   return Object.freeze({
//     // Execute FileReader.abort
//     abort: () => reader.abort(),
//
//     // Execute FileReader.readAsText
//     asText: async (): Promise<string> =>
//       await _read(file, reader, 'readAsText', optionals),
//
//     // Execute FileReader.readAsArrayBuffer
//     asArrayBuffer: async (): Promise<ArrayBuffer> =>
//       await _read(file, reader, 'readAsArrayBuffer', optionals),
//
//     // Execute FileReader.readAsDataURL
//     asDataURL: async (): Promise<string> =>
//       await _read(file, reader, 'readAsDataURL', optionals),
//   })
// }
//
// /**
//  * Return a Promise with file reading handler function
//  *
//  * @private
//  * @param {File} file - File object to read
//  * @param {FileReader} reader - FileReader object
//  * @param {string} method - Reader method
//  * @param {Object} optionals - Contains handlers for reading file
//  * @returns {Promise}
//  */
// function _read(file, reader, method, optionals) {
//   return new Promise((resolve, reject) => {
//     function handleEvent(type, optionals, callback) {
//       return event => {
//         get(optionals, type, noop)(event)
//
//         if (!!callback) callback()
//       }
//     }
//
//     reader.onabort = handleEvent('onAbort', optionals)
//     reader.onloadstart = handleEvent('onLoadStart', optionals)
//     reader.onloadend = handleEvent('onLoadEnd', optionals)
//     reader.onprogress = handleEvent('onProgress', optionals)
//     reader.onload = handleEvent('onLoad', optionals, () => {
//       resolve(reader.result)
//     })
//     reader.onerror = handleEvent('onError', optionals, () => {
//       reject(FILE_LOAD_ERROR_MESSAGE)
//     })
//
//     // $FlowFixMe
//     if (!!reader[method]) reader[method](file)
//   })
// }
/**
 * Covert base64 to File object
 *
 * @public
 * @param {string} url - Data url
 * @param {string} filename - File name
 * @param {?string} mimeType - Mime type
 * @returns {Promise<File>}
 */
function base64ToFile(_x, _x2, _x3) {
  return _base64ToFile.apply(this, arguments);
}
/**
 * Read image from backend
 *
 * @public
 * @param {string} url - URL for the image
 * @param {Auth} auth - User validated authentication
 * @returns {Binary}
 */
function _base64ToFile() {
  _base64ToFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, filename, mimeType) {
    var type, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          type = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
          _context.next = 3;
          return fetch(url).then(function (res) {
            return res.arrayBuffer();
          }).then(function (buf) {
            return new File([buf], filename, {
              type: type
            });
          });
        case 3:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _base64ToFile.apply(this, arguments);
}
function readFile(_x4) {
  return _readFile.apply(this, arguments);
}
/**
 * Download the target file
 *
 * @public
 * @param {string} url - Resource URL
 * @param {string} filename - Name for the file
 * @param {string} mimeType - MIME type of the file
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<any>}
 */
function _readFile() {
  _readFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url) {
    var _ref,
      auth,
      _len,
      args,
      _key,
      options,
      res,
      _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, auth = _ref.auth;
          for (_len = _args2.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = _args2[_key];
          }
          args = _merge["default"].apply(void 0, (0, _toConsumableArray2["default"])(args));
          options = _objectSpread(_objectSpread({}, args), {}, {
            importance: 'low',
            cache: args.cache || 'default'
          });
          if (!(0, _isNil["default"])(auth)) {
            options = (0, _utils.withAuth)(auth)(options);
          }
          _context2.next = 7;
          return fetch(url, options);
        case 7:
          res = _context2.sent;
          return _context2.abrupt("return", res.blob());
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _readFile.apply(this, arguments);
}
function download(url, filename, mimeType, _ref2) {
  var auth = _ref2.auth;
  var options = (0, _utils.withAuth)(auth)({});
  return (0, _requests.download)(url, filename, mimeType, options);
}

/**
 * Download the file by appending a <a> tag
 *
 * @public
 * @param {string} url - Resource URL
 */
function downloadByAnchor(url) {
  var anchor = document.createElement('a');
  anchor.setAttribute('href', url);
  anchor.setAttribute('target', '_blank');
  anchor.setAttribute('download', 'true');
  anchor.click();
}
//# sourceMappingURL=file.js.map